<div class="app-splash-screen" *ngIf="($visible | async)">
  <div class="app-splash-inner">
    <div class="app-logo">
      <img src="../../../assets/images/admiaWhite.png" />
    </div>
    <div class="app-label">loading WebApp...</div>
    <div class="app-loader"></div>

    <ion-spinner name="lines" class="app-spinner"></ion-spinner>
  </div>
</div>
